import { PUBLIC_EXPERIENCE_FORCE_LOGIN_QUERY_PARAM } from '../constants/network.constants';

export const onPublicLogin = () => {
  window.location.href = `/support/add-case?${PUBLIC_EXPERIENCE_FORCE_LOGIN_QUERY_PARAM.key}=${PUBLIC_EXPERIENCE_FORCE_LOGIN_QUERY_PARAM.value}`;
};

export const hasPublicForceLoginQueryParam = () => new URLSearchParams(window.location.search)
  .get(PUBLIC_EXPERIENCE_FORCE_LOGIN_QUERY_PARAM.key) === PUBLIC_EXPERIENCE_FORCE_LOGIN_QUERY_PARAM.value;
